export default __webpack_public_path__ + "static/media/984.8ad11ba6.png";